<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="business" title="비즈니스" src="/images/sub/subvisual-business.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section id="business-roadmap" class="page-section--first">
            <template #title>
                비즈니스 로드맵
            </template>

            <v-img :aspect-ratio="1200 / 936" src="/images/sub/business/roadmap-img.png" data-aos="fade" />
        </page-section>

        <page-section-image id="business-solution" imageSrc="/images/sub/business/business-img.jpg">
            <template #title>
                <h4 class="tit tit--lg">이레아이에스 자체 개발 <br class="d-none d-lg-block" />작물 생장 제품 솔루션 제공</h4>
            </template>
            <template #text>
                <p>지속 가능한 농업을 실현하기 위해 작물을 끊임없이 연구하여 자체개발한 제품 솔루션을 제공합니다.</p>
                <p>작물을 최상의 상태로 건강하게 성장시키며, 균일한 품질과 일정한 양의 작물 재배가 가능합니다.</p>
            </template>
        </page-section-image>

        <page-section-image id="business-facility" imageSrc="/images/sub/business/business-img2.jpg" reverse>
            <template #title>
                <h4 class="tit tit--lg">농업의 생산성을 향상시키는 <br class="d-none d-lg-block" />이레아이에스 스마트팜 시설</h4>
            </template>
            <template #text>
                <p>지역과 위치에 상관없이 어디서든 다양한 형태의 농업이 가능해집니다.</p>
                <p>이레아이에스의 폭넓은 경험과 노하우로 자체 기술과 제품을 <br class="d-none d-lg-block" />이용하여 농작물의 생육환경을 최적화하는 스마트팜 시설을 <br class="d-none d-lg-block" />구축합니다.</p>
                <p>환경 친화적인 생산방식 시설 도입으로 지구의 지속 가능한 미래를 <br class="d-none d-lg-block" />실현합니다.</p>
            </template>
        </page-section-image>

        <page-section-image id="business-crop" imageSrc="/images/sub/business/business-img3.jpg">
            <template #title>
                <h4 class="tit tit--lg">스마트팜 기술이 집약된 <br class="d-none d-lg-block" />재배시스템</h4>
            </template>
            <template #text>
                <p>이레아이에스의 자체 개발 제품과 기술을 활용하여 식물을 건강하고 <br class="d-none d-lg-block" />효율적으로 재배합니다.</p>
                <p>식물의 생육환경을 실시간으로 모니터링하고, 온도, 습도, 조도 등의 <br class="d-none d-lg-block" />환경요소를 적절하게 제어하여 식물이 최적의 상태로 성장하도록 <br class="d-none d-lg-block" />합니다.</p>
            </template>
        </page-section-image>

        <page-section-image id="business-distribution" class="page-section--last" imageSrc="/images/sub/business/business-img4.jpg" reverse>
            <template #title>
                <h4 class="tit tit--lg">더 신선하고 더 건강한 <br class="d-none d-lg-block" />농산물 유통</h4>
            </template>
            <template #text>
                <p>이레아이에스의 직영 스마트팜과 연계농가에서 재배한 신선한 <br class="d-none d-lg-block" />농산물을 대형마트, 백화점, 외식 프랜차이즈 등에서 만날 수 <br class="d-none d-lg-block" />있습니다.</p>
                <p>이레아이에스의 기술로 생산한 농산물은 철저한 품질관리를 통해 <br class="d-none d-lg-block" />우수한 품질과 신선도를 자랑하며, 안전하고 건강하게 소비자에게 제공됩니다.</p>
            </template>
        </page-section-image>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import PageSectionImage from "@/pages/client/templates/page-section-image.vue";
import UTabs from "@/components/dumb/u-tabs.vue";
import UTab from "@/components/dumb/u-tab.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        PageSectionImage,
        UTabs,
        UTab,
    },
    props: {},
    data() {
        return {
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
